module.exports = __webpack_public_path__ + "img/banner_zh.2dde6c1a.png";